import React, { useState } from 'react';
import TextField from '@material-ui/core/TextField';
import SendIcon from '@material-ui/icons/Send';
import { useFeatureFlags } from 'providers/FeatureFlagsProvider';
import { Permissions, userHasPermission } from 'services/Authorization';
import strings from 'strings';
import { FPIconButton, When } from 'UI/components/atoms';
import { FPButtonMenu } from 'UI/components/molecules';
import { FeatureFlags } from 'UI/constants/featureFlags';
import { SvgArtificialIntelligence } from 'UI/res';

import { useComposerStyles } from './Composer.styled';

const COPIES = strings.ai.generators.assistant;

export const Composer = ({ disabled, onClickSend, canSelectAIModels = true, placeholder }) => {
  const classes = useComposerStyles();
  const { checkIfFeatureFlagEnabled } = useFeatureFlags();
  const [input, setInput] = useState('');

  const showSelectAIModels =
    checkIfFeatureFlagEnabled(FeatureFlags.AIAssistantSelectModels) &&
    userHasPermission(Permissions.AIIntegrations.Assistant) &&
    canSelectAIModels;

  const menuItems = [
    {
      title: COPIES.models.pacGPT.title,
      description: COPIES.models.pacGPT.description,
      action: () => {},
      visible: true
    },
    {
      title: COPIES.models.gpacUTrainer.title,
      description: COPIES.models.gpacUTrainer.description,
      action: () => {},
      visible: true
    }
  ];

  const handleChangeText = e => {
    setInput(e.target.value);
  };

  const handleClickSend = () => {
    if (disabled) return;
    const message = input.trim();
    if (!message) return;

    onClickSend && onClickSend(message);
    setInput('');
  };

  const handleKeyDown = e => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleClickSend();
    }
  };

  return (
    <div className={classes.composerContainer}>
      <When condition={showSelectAIModels}>
        <FPButtonMenu
          edge="end"
          icon={SvgArtificialIntelligence}
          isIconButton
          menuItems={menuItems}
          title={COPIES.models.select}
        />
      </When>

      <TextField
        fullWidth
        multiline
        onChange={handleChangeText}
        onKeyDown={handleKeyDown}
        placeholder={placeholder || COPIES.composer.placeholder}
        minRows={2}
        maxRows={12}
        value={input}
        variant="outlined"
        disabled={disabled}
      />

      <FPIconButton
        aria-label={strings.shared.ui.send}
        onClick={handleClickSend}
        tooltipProps={{
          title: strings.shared.ui.send
        }}
        disabled={disabled}
      >
        <SendIcon color={disabled ? 'disabled' : 'primary'} />
      </FPIconButton>
    </div>
  );
};
